import { request } from "@/api/request";

export async function getMerchantList(args) {
  const list = await request({
    url: "/merchants",
    method: "get",
    params: args,
  });
  return list;
}

export async function getMerchantInfo(ident) {
  const info = await request({
    url: "/merchants/" + ident,
    method: "get",
  });
  return info;
}

export async function getMerchantValidate(ident) {
  const merchant = await request({
    url: "/merchants/" + ident + "/validate",
    method: "get",
  });
  return merchant;
}

export async function getMerchantAccounts(ident) {
  const data = await request({
    url: "/merchants/" + ident + "/accounts",
    method: "get",
  });
  return data;
}

export async function linkMerchantAccount(merchantIdent, user_email) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/accounts",
    method: "post",
    data: {
      user_email,
    },
  });
  return data;
}

export async function unlinkMerchantAccount(merchantIdent, userIdent) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/accounts/" + userIdent,
    method: "delete",
  });
  return data;
}

export async function updateMerchantAccountRoles(
  merchantIdent,
  userIdent,
  roles
) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/accounts/" + userIdent,
    method: "post",
    data: {
      roles,
    },
  });
  return data;
}

export async function inviteMerchantAccount(merchantIdent, payload) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/invite-account",
    method: "post",
    data: payload,
  });
  return data;
}

export async function createMerchant(merchantData) {
  const merchant = await request({
    url: "/merchants",
    method: "post",
    data: merchantData,
  });
  return merchant;
}

export async function updateMerchant(merchantIdent, merchantData) {
  const merchant = await request({
    url: "/merchants/" + merchantIdent,
    method: "post",
    data: merchantData,
  });
  return merchant;
}

export async function getMerchantImages(merchantIdent) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/images",
    method: "get",
  });
  if (data) {
    return data;
  }
}

export async function uploadMerchantImage(args) {
  const data = await request({
    url: "/merchants/" + args.merchantIdent + "/images",
    method: "post",
    data: {
      filename: args.filename,
      file: args.file,
    },
  });
  if (data) {
    return data;
  }
}

export async function removeMerchantImage(merchantIdent, image) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/images/" + image,
    method: "delete",
  });
  if (data) {
    return data;
  }
}

export async function setMerchantImageRole(args) {
  const data = await request({
    url: "/merchants/" + args.merchantIdent + "/image-role/",
    method: "post",
    data: {
      image: args.image,
      role: args.role,
    },
  });
  if (data) {
    return data;
  }
}

export async function getMerchantContacts(merchantIdent) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/contacts",
    method: "get",
  });
  return data;
}

/*
export async function storeMerchantContacts(merchantIdent, contacts) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/contacts",
    method: "post",
    data: contacts
  });
  return data;
}*/

export async function apiDashboard(merchantIdent) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/dashboard",
    method: "get",
  });
  return data;
}

export async function apiStats(merchantIdent, args) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/stats",
    method: "get",
    params: args,
  });
  return data;
}

export async function apiGetTimeframeCampaigns(merchantIdent, args) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/stats/campaigns",
    method: "get",
    params: args,
  });
  return data;
}

export async function getMerchantLocations(merchantIdent) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/locations",
    method: "get",
  });
  return data;
}

export async function addMerchantLocation(merchantIdent, location) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/locations",
    method: "post",
    data: {
      location,
    },
  });
  return data;
}

export async function getLocation(merchantIdent, location_id) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/locations/" + location_id,
    method: "get",
  });
  return data;
}

export async function updateMerchantLocation(
  merchantIdent,
  location_id,
  location
) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/locations/" + location_id,
    method: "post",
    data: {
      location,
    },
  });
  return data;
}

export async function deleteMerchantLocation(merchantIdent, location_id) {
  const data = await request({
    url: "/merchants/" + merchantIdent + "/locations/" + location_id,
    method: "delete",
  });
  return data;
}

export async function apiUploadLocations(args, file) {
  const formData = new FormData();
  formData.append("upload", file, file.name);
  const rv = await request({
    url: "/merchants/" + args.merchantIdent + "/multiple-locations",
    method: "post",
    data: formData,
    config: { headers: { "Content-Type": "multipart/form-data" } },
  });
  return rv;
}
